import { useTranslation } from "react-i18next";
import { Box } from "../../../../../components/styled/Elements";
import { PropertiesListingWrapper } from "../../properties/styled";
import VisitorPropertiesCards from "./VisitorPropertyCard";

const VisitorPropertiesList = ({ showAll, setShowAll, listings, user }) => {
  const { t } = useTranslation();
  return (
    <PropertiesListingWrapper>
      <Box className="w-100">
        <VisitorPropertiesCards showAll={showAll} setShowAll={setShowAll} listings={listings} user={user} />
      </Box>
    </PropertiesListingWrapper>
  );
};

export default VisitorPropertiesList;
